export function getOSSImage(name: string) {
    return `https://oss.animepop.net/static/homepage/${name}`;
}